import { render, staticRenderFns } from "./OrderNew1.vue?vue&type=template&id=7352b554&scoped=true"
import script from "./OrderNew1.vue?vue&type=script&lang=js"
export * from "./OrderNew1.vue?vue&type=script&lang=js"
import style0 from "./OrderNew1.vue?vue&type=style&index=0&id=7352b554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352b554",
  null
  
)

export default component.exports